import React, { useState } from "react";
import { navigate } from "gatsby";
import data from "../../data/data.json";
import SearchBar from "./SearchBar";

const ParentComponent = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (results) => {
    setSearchResults(results);

    // Navigate to the SearchResult page and pass the results and searchTerm in the state
    navigate("/search-result/", { state: { results, searchTerm } });
  };

  return (
    <div>
      <SearchBar
        data={data}
        onSearch={handleSearch}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};

export default ParentComponent;
